import PropTypes from 'prop-types';
import styles from 'styles/shop/product.module.css';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHover } from 'hooks/mouse';
import Mouse from 'ui/mouse';
import Axios from 'axios';

function ZoomableImage({
  url,
  zoomRef: ref
}) {

  const [state, setState] = useState(url);

  const fetchOriginal = useCallback(async () => {
    try {
      const parts = url.split('.');
      const extension = parts.pop();
      parts.push('original');
      parts.push(extension);
      const original = parts.join('.');
      await Axios.head(original);
      setState(original);
    } catch (e) {
      console.error(e);
    }
  }, [url]);

  useEffect(() => {
    setState(url);
    fetchOriginal();
  }, [url]);

  const [imgRef, isHovered] = useHover();
  const lensRef = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.style.display = isHovered ? 'block' : 'none';
    }
  }, [isHovered]);

  const moveLens = (e) => {
    const result = ref.current;
    const currentImg = e.target;
    const lens = lensRef.current;
    const cx = result.offsetWidth / lens.offsetWidth;
    const cy = result.offsetHeight / lens.offsetHeight;
    const pos = Mouse.getCursorPos(e);
    const x = pos.x - (lens.offsetWidth / 2);
    const y = pos.y - (lens.offsetHeight / 2);
    result.style.backgroundImage = `url('${currentImg.src}')`;
    result.style.backgroundSize = `${currentImg.width * cx}px ${currentImg.height * cy}px`;
    result.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
  };

  return (
    <>
      <div ref={lensRef} className={styles.lens}/>
      <img
        ref={imgRef}
        className={styles.product}
        onMouseMove={moveLens}
        src={state}
        alt=""
      />
    </>
  );
}

ZoomableImage.propTypes = {
  url: PropTypes.string.isRequired,
  zoomRef: PropTypes.object.isRequired,
};

export default ZoomableImage;
